import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">Mustafa Yusuf Karanjawala</h1>
          <PText>
            A frontend and backend software engineer with a year of experience
            working as webmaster.Self Starter quick learner and having expert in
            business development and website networking, blogs reaching over the
            thousands of active users and serving the company by innovative
            ideas..
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                link: '/',
                type: 'Link',
              },
              {
                type: 'Link',
                title: 'About',
                link: '/about',
              },
              {
                type: 'Link',
                title: 'Projects',
                link: '/projects',
              },
              {
                type: 'Link',
                title: 'Contact',
                link: '/contact',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: '+91 8446518154',
                link: 'tel:+918446518154',
              },
              {
                title: 'mustufakaranjawala72@gmail',
                link: 'mailto:mustufakaranjawala72@gmail',
              },
              {
                title: 'Nagpur',
                link: 'http://google.com/maps',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="social Links"
            links={[
              {
                title: 'Linkedin',
                link: 'https://www.linkedin.com/in/mustafa-yusuf-karanjawala-a54833198/',
              },
              {
                title: 'Github',
                link: 'https://github.com/mustafakaranja',
              },
              {
                title: 'Instagram',
                link: 'http://instagram.com/mustafakaranja',
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>
            © 2021 - Photo-G Technologies | Designed By{' '}
            <a target="_blank" rel="noreferrer" href="https://photogtech.in">
              Mustufa Karanjawala
            </a>{' '}
          </PText>
        </div>
      </div>
    </FooterStyle>
  );
}
